import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { partnerService } from "../../Services/partner.service";
import ListAdminButtons from "../Common/ListAdminButtons";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import DeleteModal from "../Partners/DeleteModal";
import SpinnerLoading from "../Common/SpinnerLoading";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import Tooltip from "../../Components/Common/Tooltip";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import XLSX from "xlsx";
const Index = ({ tenantId }) => {
  const { isMobile, locTab } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const { roleId } = useContext(AuthContext);
  const { cashier, accountant } = roles;
  const [partners, setPartners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 5,
    pageIndex: 0,
    sortName: "Name",
    isAsc: true,
  });
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });
  const [update, setUpdate] = useState(new Date());
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchName, setSearchName] = useState("");
  const history = useHistory();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    if (locTab === "partners") {
      partnerService
        .get({
          searchName,
          tenantId,
          pageIndex: pagination.pageIndex,
          pageSize: pagination.pageSize,
          sortName: pagination.sortName,
          isAsc: pagination.isAsc,
        })
        .then((res) => {
          setIsLoading(false);
          setPartners(res.data.partners);
          setPagination({ ...pagination, totalCount: res.data.totalCount });
        })
        .catch((err) => {
          console.error(err.response);
        });
    }
  }, [update, searchName, locTab]);

  const handleClose = () => {
    setModal({ show: false });
  };

  const handleToUpdate = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/update-partner/${selectedItems}`);
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems([...selectedItems, row.partnerGuid]);
    } else {
      setSelectedItems(selectedItems.filter((p) => p !== row.partnerGuid));
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      setSelectedItems(partners.map((x) => x.partnerGuid));
    } else {
      setSelectedItems([]);
    }
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target.cellIndex) {
        history.push(`/update-partner/${row.partnerGuid}`);
      }
    },
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={selectedItems.find((x) => x === row.partnerGuid)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }
  const handleBulkImport = () => {
    history.push(`/partner-bulk-import/${tenantId}`);
  };

  const handleExport = () => {
    partnerService
      .get({
        searchName,
        tenantId,
        pageIndex: 0,
        pageSize: pagination.totalCount,
        sortName: pagination.sortName,
      })
      .then((res) => {
        console.log("RRR", res.data.partners);

        let wb = XLSX.utils.book_new();

        const wsItemsHeading = [
          [
            translator("Id"),
            translator("Naziv"),
            translator("Oib"),
            translator("Napomena"),
            translator("Ulica"),
            translator("Kućni broj"),
            translator("Dodatak kućnog broja"),
            translator("Grad"),
            translator("Poštanski broj"),
            translator("Država"),
            translator("IBAN"),
            translator("Telefon"),
            translator("Email"),
            translator("Branch"),
          ],
        ];
        let wsItems = XLSX.utils.aoa_to_sheet(wsItemsHeading);
        XLSX.utils.sheet_add_json(
          wsItems,
          res.data.partners.map((x) => {
            return {
              id: x.partnerGuid,
              name: x.name,
              taxNumber: x.taxNumber,
              description: x.description,
              street: x.street,
              streetNumber: x.streetNumber,
              streetNumberExtension: x.streetNumberExtension,
              city: x.city,
              postalNumber: x.postalNumber,
              country: x.countryId,
              iban: x.iban,
              phone: x.phone,
              email: x.email,
              branch: x.branch,
            };
          }),
          {
            header: [
              "id",
              "name",
              "taxNumber",
              "description",
              "street",
              "streetNumber",
              "streetNumberExtension",
              "city",
              "postalNumber",
              "country",
              "iban",
              "phone",
              "email",
            ],
            skipHeader: true,
            origin: -1,
          }
        );

        XLSX.utils.book_append_sheet(wb, wsItems, "Partneri");

        const fileName = "Partneri.xlsx";
        XLSX.writeFile(wb, fileName);
      });
  };

  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={
              partners &&
              partners.length > 0 &&
              !partners
                .map((p) => p.partnerGuid)
                .some((p) => selectedItems.indexOf(p) < 0)
            }
            onChange={(e) => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="partnerGuid"
        data={data}
        columns={columns}
        rowEvents={rowEvents}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const columns = [
    {
      dataField: "partnerGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
      formatter: actionFormatter,
      hidden: [cashier, accountant].includes(Number(roleId)) ? true : false,
    },
    {
      dataField: "name",
      text: translator("Partners-PartnersTab-TableHeader-Name"),
    },
    {
      dataField: "street",
      text: translator("Partners-PartnersTab-TableHeader-Street"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "taxNumber",
      text: translator("Partners-PartnersTab-TableHeader-TaxNumber"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "phone",
      text: translator("Partners-PartnersTab-TableHeader-PhoneNumber"),
      hidden: Boolean(isMobile),
    },
  ];

  const addPartner = () => {
    history.push("/addpartner");
  };

  const handleHideDeleteModal = () => setShowDeleteModal(false);

  const confirmDelete = () => {
    let deletePromises = [];

    selectedItems.forEach((x) => {
      deletePromises.push(partnerService.deletePartner(x));
    });

    Promise.all(deletePromises)
      .then((data) => {
        setShowDeleteModal(false);
        setModal({
          ...modal,
          title: translator("Partners-PartnersTab-SuccesDeleteModal-Title"),
          text: translator("Partners-PartnersTab-SuccesDeleteModal-Text"),
          show: true,
          btnClass: "btn btn-primary",
        });
        setUpdate(new Date());
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: translator("Partners-PartnersTab-UnsuccesDeleteModal-Title"),
          text: translator("Partners-PartnersTab-UnsuccesDeleteModal-Text"),
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  return (
    <div className="p-2">
      <div className="container-fluid p-0">
        <div className="card-body pl-0 mb-4">
          <div className="form-inline">
            <input
              style={{ width: "180px", marginRight: "6px" }}
              type="text"
              placeholder={translator("Partners-Tab-Search")}
              className="form-control"
              value={searchName}
              onChange={(event) => {
                setSearchName(event.target.value);
                setPagination({ ...pagination, pageIndex: 0 });
              }}
            />
            <Tooltip text={translator("Tabs-Search")} />
          </div>

          <ListAdminButtons
            selectedItemsLength={selectedItems.length}
            handleToUpdate={
              [cashier, accountant].includes(Number(roleId))
                ? null
                : handleToUpdate
            }
            handleDelete={
              [cashier, accountant].includes(Number(roleId))
                ? null
                : () => setShowDeleteModal(true)
            }
            handleToAdd={
              [cashier, accountant].includes(Number(roleId)) ? null : addPartner
            }
            handleBulkImport={handleBulkImport}
            handleExport={handleExport}
          />

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={partners}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
              handleToAdd={addPartner}
            />
          )}
        </div>
      </div>

      <DeleteModal
        show={showDeleteModal}
        handleHide={handleHideDeleteModal}
        title={translator("TenantDetail-PartnersTab-DeleteModal-Title")}
        text={translator("TenantDetail-PartnersTab-DeleteModal-Text")}
        confirmDelete={confirmDelete}
      />
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </div>
  );
};

export default Index;
